export const MAX_TITLE_LENGTH = 100;
export const MAX_DESCRIPTION_LENGTH = 300;
export const MAX_ITEMS_LENGTH = 10;
export const MIN_ITEMS_LENGTH = 2;
